import styled from "styled-components";

export default styled.div.attrs(props => ({
  id: props.id
}))`
  cursor: ${props => props.cursor || "default"}!important;
  display: flex;
  align-items: ${props => props.align || "center"};
  flex-direction: row;
  flex-wrap: wrap;
  min-height: ${props => props.minheight};
  margin-top: ${props => props.margintop};
  margin-bottom: ${props => props.marginbottom};
  margin-right: ${props => props.marginright};
  margin-left: ${props => props.marginleft};
  padding: ${props => props.padding};
  align-items: ${props => props.verticalalign};
  min-width: ${props => props.minwidth};
  max-width: ${props => props.maxwidth || "500px"};
  justify-content: ${props => props.justifyContent};
  width: ${props => props.width};
`;
